import React from "react";
import EirButton from "../eir-button/EirButton"
import {makeStyles} from "@material-ui/core/styles"

function CarouselCtaButton ({cta, isAlignCenter}){

    let centerAlignmentStyle = isAlignCenter ? {
        margin:"0 12px !important",
        flex:"1 !important",
    } : {} 

    let editorCtaBtnStyle = {
        borderWidth: "3px !important",
        ...centerAlignmentStyle
    }

    let editorCtaLinkStyle = {
        ...centerAlignmentStyle
    }
    
    let inlineStyle = makeStyles({
        root:{
            '& a': cta.ctaType=="link"?editorCtaLinkStyle:editorCtaBtnStyle, 
            '& button': cta.ctaType=="link"?editorCtaLinkStyle:editorCtaBtnStyle,           
        }
    })

    const btnStyling = {
        backgroundColor: cta.ctaBgColor ,
        color: cta.ctaFontColor,
        borderColor: `${ cta.ctaOutline === "true" ? cta.ctaBorderColor : cta.ctaBgColor}`,
        hover: {
            borderColor: cta.ctaBorderHoverColor,
            color: cta.ctaFontHoverColor,
            backgroundColor: cta.ctaBgHoverColor,
        }
    }

    const classes = cta.ctaType=="link"?"cta-link-type":"cta-btn-type"

    return (
        <div className={`carousel-cta-button ${inlineStyle().root} ${classes}`}> 
            <EirButton 
                color={"primary"}
                outline={cta.ctaOutline=="true"?true:false}
                type={cta.ctaType}
                text={cta.ctaText}
                className={`eir-text-secondary ${cta.ctaVideoModal== "true" ? "cta-video-btn" : "" }` }
                link={cta.ctaLink}
                videoModal={(cta.ctaVideoModal === "true")}
                target={cta.ctaTarget!="false"?cta.ctaTarget:"_self"}
                title={cta.ctaTitle}
                buttonStyle={cta.buttonStyle}
                buttonSize={cta.buttonSize}
                icon={cta.ctaIcon?cta.ctaIcon:undefined}
                styling={btnStyling}
                theme={cta.theme}
                ariaLabel={cta.ctaAriaLabel}
                > {cta.ctaText} </EirButton>
        </div>)
}

export default CarouselCtaButton;